<template>
  <FlexTable class="cardio-table">
    <div class="flex-th table-title">{{ title }}</div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th">Máquina</div>
      <div class="flex-th">Programa</div>
      <div class="flex-th">Nivel</div>
      <div class="flex-th num-cell">Tiempo</div>
      <div class="flex-th num-cell">F. Cardíaca</div>
      <div class="flex-th">Observaciones</div>
    </div>
    <div class="flex-trow flex-trow-content" v-if="exercise">
      <div class="flex-td editable-cell">
        <EditableCellInput v-model="exercise.exercise_or_machine" :is-textarea="true" />
      </div>
      <div class="flex-td editable-cell">
        <EditableCellInput v-model="exercise.program"  :is-textarea="true" />
      </div>
      <div class="flex-td editable-cell">
        <EditableCellInput v-model="exercise.level"  :is-textarea="true" />
      </div>
      <div class="flex-td editable-cell num-cell with-unit">
        <EditableCellInput v-model="exercise.time_in_minutes" type="number"/>
        <EditableCellSelect disabled value="min"/>
      </div>
      <div class="flex-td editable-cell num-cell with-unit">
        <EditableCellInput v-model="exercise.cardiac_freq_in_bpm" type="number"/>
        <EditableCellSelect disabled value="bpm"/>
      </div>
      <div class="flex-td editable-cell">
        <EditableCellInput v-model="exercise.observations"  :is-textarea="true" />
      </div>
    </div>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect'

export default {
  name: "CardioTable",
  components: { EditableCellSelect, EditableCellInput, FlexTable },
  model: {
    prop: "exercise",
    event: "change"
  },
  props: {
    exercise: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: String,
      default: "Cardiovascular"
    }
  },
  data: function() {
    return {
      dataExercise: this.exercise
    };
  },
  watch: {
    dataExercise: function(val) {
      this.$emit("change", val);
    },
  }
};
</script>

<style scoped lang="scss">
$cardio-table-base-color: theme-color("secondary");
$cardio-table-title-bg-color: $cardio-table-base-color;
$cardio-table-title-color: $white;
$cardio-table-header-bg-color: rgba($cardio-table-base-color, 0.1);
$cardio-table-header-color: darken($cardio-table-base-color, 25);

.cardio-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
}

.flex-th.table-title {
  background-color: $cardio-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $cardio-table-header-bg-color;
  color: $cardio-table-header-color;
  padding: 0.25rem;
}

.flex-trow-header > .flex-th, .flex-trow-content > .flex-td {
  flex: 1 0 9rem;
  min-width: 9rem;
  max-width: 9.7rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
  min-width: 6rem;
  max-width: 8rem;
}

.with-unit {
  position: relative;

  & input {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    color: $gray-500;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      color: $body-color;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active, &:focus {
      color: $body-color;
      background-color: $active-background-color;
    }
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>